<template>
  <div :class="{
    'sidebar': true,
    [side]: true,
    'show': show
  }">
    <slot class="header"
          name="header" />
    <slot class="content" />
    <slot class="footer"
          name="footer" />
  </div>
</template>

<script>

export default {
  name: 'Sidebar',
  props: {
    show: {
      type: Boolean,
      default: false,
      required: false
    },
    side: {
      type: String,
      default: 'left',
      required: false
    }
  }
}

</script>

<style>

.sidebar {
  height: 100%;
  width: 270px;
  position: fixed;
  z-index: 999;
  top: 0;
  background-color: #ffffff;
  box-shadow: 0 0 16px 10px rgba(0, 0, 0, .02);
  overflow-x: hidden;
  transition: 0.2s ease-in-out;
}

.sidebar ~ * {
  transition: 0.2s ease-in-out;
}

.sidebar.left {
  transform: translateX(-270px);
}

.sidebar.left.show {
  transform: translateX(0px);
}

.sidebar.left.show ~ * {
  transform: translateX(270px);
}

.sidebar.right {
  right: 0;
  transform: translateX(270px);
}

.sidebar.right.show {
  transform: translateX(0px);
}

.sidebar.right.show ~ * {
  transform: translateX(-270px);
}

.sidebar .header {}

.sidebar .content {
  padding: .8rem 1.2rem;
}

.sidebar .footer {}

</style>



// WEBPACK FOOTER //
// Sidebar.vue?2709caa3